<template>
  <v-container grid-list-xl>
    <v-form lazy-validation>
      <v-layout row wrap>
        <v-flex
          v-for="componente in formComponentList"
          xs12
          :key="componente.id"
          v-show="componente.isVisible || componente.isVisible == undefined"
        >
          <p v-if="componente.type == 'statement'">{{ componente.label }}</p>

          <p class="mb-0 pb-0 custom-label">
            {{ componente.label }}
            <v-tooltip slot="append" bottom v-if="componente.help">
              <v-icon slot="activator" color="primary" dark>info</v-icon>
              <span>{{ componente.help }}</span>
            </v-tooltip>
          </p>

          <v-autocomplete
            v-if="componente.type == 'select'"
            v-model="item[componente.id]"
            :no-data-text="'Nenhum resultado encontrado.'"
            :items="componente.options"
            :placeholder="
              componente.description ? componente.description : 'Selecionar'
            "
            :rules="componente.required ? [rules.obrigatório] : []"
            :disabled="!componente.editable"
            @change="setVisible(componente)"
            class="form-select-box"
          ></v-autocomplete>

          <v-text-field
            v-if="componente.type == 'cnpj' || componente.type == 'cpf'"
            v-model="item[componente.id]"
            v-mask="
              componente.type == 'cnpj'
                ? '##.###.###/####-##'
                : '###.###.###-##'
            "
            :placeholder="componente.description ? componente.description : ' '"
            :rules="
              componente.required
                ? [rules.obrigatório, rules[componente.type]]
                : [rules[componente.type]]
            "
            :readonly="!componente.editable"
            @change="setVisible(componente)"
            class="jns-input"
          ></v-text-field>

          <v-text-field
            v-if="componente.type == 'short_text'"
            v-model="item[componente.id]"
            :placeholder="componente.description ? componente.description : ' '"
            :rules="componente.required ? [rules.obrigatório] : []"
            :readonly="!componente.editable"
            @change="setVisible(componente)"
            class="jns-input"
          ></v-text-field>

          <v-text-field
            v-if="componente.type == 'email' || componente.type == 'phone'"
            v-model="item[componente.id]"
            v-mask="
              componente.type == 'phone'
                ? ['## ####-####', '## #####-####']
                : ''
            "
            :placeholder="componente.description ? componente.description : ' '"
            :rules="
              componente.required
                ? [rules.obrigatório, rules[componente.type]]
                : [rules[componente.type]]
            "
            :readonly="!componente.editable"
            @change="setVisible(componente)"
            class="jns-input"
          ></v-text-field>

          <v-text-field
            v-if="componente.type == 'id' || componente.type == 'number'"
            v-model="item[componente.id]"
            v-mask="componente.type == 'number' ? '####################' : ''"
            :placeholder="componente.description ? componente.description : ' '"
            :rules="componente.required ? [rules.obrigatório] : []"
            :readonly="!componente.editable"
            @change="setVisible(componente)"
            class="jns-input"
          ></v-text-field>

          <v-text-field
            v-if="componente.type == 'currency'"
            v-model="item[componente.id]"
            v-money="$settings.moneyConfig"
            :rules="componente.required ? [rules.obrigatório] : []"
            :readonly="!componente.editable"
            @emptied="item[componente.id] = 0"
            @change="setVisible(componente)"
            class="jns-input"
            placeholder=" "
          ></v-text-field>

          <v-textarea
            v-if="componente.type == 'long_text'"
            v-model="item[componente.id]"
            :rules="componente.required ? [rules.obrigatório] : []"
            :readonly="!componente.editable"
            @change="setVisible(componente)"
            class="jns-input"
            placeholder=" "
          ></v-textarea>

          <v-menu
            v-if="componente.type == 'date'"
            v-model="pickerMenu[componente.id]"
            :nudge-right="40"
            :close-on-content-click="false"
            :disabled="!componente.editable"
            :rules="componente.required ? [rules.obrigatório] : []"
            @change="setVisible(componente)"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            max-width="290px"
            min-width="290px"
          >
            <v-text-field
              v-model="dateFormatter[componente.id]"
              slot="activator"
              class="jns-input jns-datepicker"
              append-icon="event"
              placeholder=" "
              :disabled="!componente.editable"
              :readonly="true"
            ></v-text-field>
            <v-date-picker
              v-model="item[componente.id]"
              @change="pickerMenu[componente.id] = false"
              @input="setDataFormat(componente.id)"
              no-title
              scrollable
              locale="pt-BR"
              actions
              autofocus
            >
            </v-date-picker>
          </v-menu>

          <v-layout
            row
            wrap
            class="check-list-group"
            v-if="
              componente.type == 'checklist_horizontal' ||
              componente.type == 'checklist_vertical'
            "
          >
            <v-flex
              :class="
                componente.type == 'checklist_horizontal'
                  ? 'check-list md4 sm6 xs12'
                  : 'check-list xs12'
              "
              v-for="opcao in componente.options"
              :key="`${opcao}_${componente.id}`"
            >
              <label
                :class="componente.hasError ? 'has-error-text' : ''"
                :readonly="!componente.editable"
                @click="setSelected(componente, opcao)"
              >
                <i
                  :class="
                    getSelected(componente, opcao)
                      ? 'material-icons checked'
                      : 'material-icons'
                  "
                >
                  {{
                    getSelected(componente, opcao)
                      ? "check_box"
                      : "check_box_outline_blank"
                  }}</i
                >
                <p>{{ opcao }}</p>
              </label>
            </v-flex>
          </v-layout>

          <v-radio-group
            v-if="
              componente.type == 'radio_horizontal' ||
              componente.type == 'radio_vertical'
            "
            v-model="item[componente.id]"
            :column="componente.type == 'radio_vertical'"
            :row="componente.type == 'radio_horizontal'"
            :rules="componente.required ? [rules.obrigatório] : []"
            :readonly="!componente.editable"
            @change="setVisible(componente)"
          >
            <v-radio
              v-for="opcao in componente.options"
              :key="`${opcao}_${componente.id}`"
              :label="opcao"
              :value="opcao"
            ></v-radio>
          </v-radio-group>

          <documento-upload
            v-if="componente.type == 'attachment'"
            :id-documento="componente.id"
            :nome-documento="componente.label"
            @select="handleSelectedFile"
            @remove="removeFile"
            @typeFailed="showUploadIsntPDF()"
            :class="componente.hasError ? 'anexo-list has-error' : 'anexo-list'"
            @change="setVisible(componente)"
          ></documento-upload>
          <p mt-2 class="has-error-text" v-if="componente.hasError">
            Anexo obrigatório
          </p>
        </v-flex>
      </v-layout>
    </v-form>
  </v-container>
</template>

<script lang="js">
import { VMoney } from "v-money";
import { formatDate, isValidCpf, isValidCnpj } from "@/libs/utils";
import ViewMixin from "@/mixins/ViewMixin";

export default {
  name: "FormDynamic",
  directives: { money: VMoney },
  mixins: [ViewMixin],
  data: () => ({
    item: {},
    dateFormatter: {},
    pickerMenu: {},
    formComponentList: [],
    rulesCompotent: [],
    rules: {
      obrigatorio: (v) => !!v || "Campo obrigatório",
      cpf: (v) => !v || isValidCpf(v) || "CPF inválido",
      cnpj: (v) => !v || isValidCnpj(v) || "CNPJ inválido",
      email: (v) =>
        !v ||
        /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
        "E-mail inválido",
      phone: (v) =>
        !v ||
        /^(\([0-9]{2}\))\s([9]{1})?([0-9]{4})-([0-9]{4})$/.test(v) ||
        "Telefone inválido",
      currency: (v) =>
        !v ||
        parseFloat(
          v
            .replace(",", ".")
            .replace(/[^0-9\.]/g, "")
            .replace("R$", "")
        ) > 0 ||
        "Valor deve ser maior que R$ 0,00",
    },
  }),
  props: {
    typeForm: String,
  },
  methods: {
    async getFormDynamic() {
      this.showLoadingAskWait();
      var data = {};

      try {
        data = await this.$store.dispatch("GET_FORM_DYNAMIC", this.typeForm);
      } catch (e) {
        this.setErrorModal(e.response.data);
        return;
      } finally {
        this.hideLoadingAskWait();
      }

      if (data.pipe.startFormFieldConditions)
        this.rulesCompotent = data.pipe.startFormFieldConditions;
      if (data.pipe.start_form_fields) {
        this.formComponentList = data.pipe.start_form_fields;
        this.formComponentList.forEach((componente) => {
          this.setVisible(componente);
        });
      }
    },

    initCheckList(componente) {
      if (componente.is_multiple) this.item[componente.id] = [];
      else this.item[componente.id] = "";
    },

    getSelected(componente, opcao) {
      if (componente.is_multiple)
        return (
          this.item[componente.id] &&
          this.item[componente.id].indexOf(opcao) >= 0
        );
      else return this.item[componente.id] == opcao;
    },

    setVisible(componentex) {
      for (var i = 0; i < this.rulesCompotent.length; i++) {
        let element = this.rulesCompotent[i];
        let isValidOr = false;
        let isValidEnd = true;
        let isUndefined = false;

        for (var j = 0; j < element.condition.expressions.length; j++) {
          let condition = element.condition.expressions[j];
          let componente = this.formComponentList.filter(function (filtro) {
            return filtro.internal_id == condition.field_address;
          })[0];

          if (!this.item[componente.id]) isUndefined = true;
          else
            switch (condition.operation) {
              case "equals":
                if (element.condition.expressions_structure.length == 1) {
                  if (
                    !this.item[componente.id] ||
                    this.item[componente.id] != condition.value
                  )
                    isValidEnd = false;
                } else {
                  if (
                    this.item[componente.id] &&
                    this.item[componente.id] == condition.value
                  )
                    isValidOr = true;
                }
                break;
              case "string_contains":
                if (element.condition.expressions_structure.length == 1) {
                  if (
                    !this.item[componente.id] ||
                    !this.item[componente.id].includes(condition.value)
                  )
                    isValidEnd = false;
                } else {
                  if (
                    this.item[componente.id] &&
                    this.item[componente.id].includes(condition.value)
                  )
                    isValidOr = true;
                }
                break;
              default:
                break;
            }
        }

        this.validAction(
          element.actions,
          element.condition.expressions_structure.length == 1
            ? isValidEnd
            : isValidOr,
          isUndefined
        );
      }
    },

    validAction(actions, isValidExpression, isUndefined) {
      let componentId;
      let componente;
      let isVisible = true;
      let thereShow = false;
      let thereHide = false;

      for (var i = 0; i < actions.length; i++) {
        componente = this.formComponentList.filter(function (filtro) {
          return filtro.internal_id == actions[i].phaseField.internal_id;
        })[0];

        if (componentId != componente.id) {
          this.formComponentList.forEach((componenteOld) => {
            if (componenteOld.id == componentId) {
              // this.item[componenteOld.id] = undefined;
              componenteOld.isVisible =
                thereShow && thereHide ? isVisible : componenteOld.isVisible;
            }
          });
          componentId = componente.id;
          isVisible = true;
          thereShow = false;
          thereHide = false;
        }

        switch (actions[i].actionId) {
          case "show":
            if (actions[i].whenEvaluator != isValidExpression || isUndefined)
              isVisible = false;
            thereShow = true;
            break;
          case "hide":
            if (actions[i].whenEvaluator == isValidExpression || isUndefined)
              isVisible = false;
            thereHide = true;
            break;
          default:
            break;
        }

        if (i + 1 == actions.length) {
          // this.item[componente.id] = undefined;
          componente.isVisible =
            thereShow && thereHide ? isVisible : componente.isVisible;
        }
      }
      this.$forceUpdate();
    },

    setDataFormat(atributo) {
      this.dateFormatter[atributo] = formatDate(
        this.item[atributo]
      );
      this.$forceUpdate();
    },

    setSelected(componente, opcao) {
      if (componente.is_multiple) {
        if (!this.item[componente.id]) this.item[componente.id] = [];

        var index = this.item[componente.id].indexOf(opcao);
        if (index >= 0) this.item[componente.id].splice(index, 1);
        else this.item[componente.id].push(opcao);
      } else {
        if (this.item[componente.id] === opcao) this.item[componente.id] = null;
        else this.item[componente.id] = opcao;
      }

      this.setVisible(componente);
    },

    //anexos metodos
    handleSelectedFile(data) {
      this.documentosSolicitados.forEach((categoria) => {
        categoria.listagem.forEach((item) => {
          if (item.id == data.idDocumento) {
            item.nome = data.nome_arquivo;
            item.arquivo = data.base64File;
          }
        });
      });

      this.$emit("validaAnexos");
      this.$forceUpdate();
    },

    removeFile(data) {
      this.documentosSolicitados.forEach((categoria) => {
        categoria.listagem.forEach((item) => {
          if (item.id == data.idDocumento) {
            item.nome = null;
            item.arquivo = null;
          }
        });
      });

      this.$emit("validaAnexos");
    },

    showUploadIsntPDF() {
      this.$store.commit("SET_ALERT_TEXT", {
        type: "error",
        message:
          "Seu arquivo não é do formato PDF. Tente novamente com um arquivo de extensão PDF.",
      });
      this.alertText = this.handleAlertText();
    },
  },
  created() {
    this.getFormDynamic();
  },
};
</script>

<style lang="scss" scoped>
.anexo-list {
  margin: 1.8vh 0.5vh 2vh 0vh !important;
}

.check-list-group {
  margin-bottom: 1.8vh;
  margin-top: 1.8vh !important;
}

.error--text {
  color: #ff5252 !important;
  caret-color: #ff5252 !important;
}
</style>



// WEBPACK FOOTER //
// ./src/components/FormDynamic.vue